const doc = [({"en":({"js":({"merfoto":({"orders":({"total_with_delivery":({"delivery":"Levering", "total_price_including_vat":"Total price (including vat):"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;